import { useState, useEffect } from 'react';

import packageJson from '../package.json';

global.appVersion = packageJson.version;

const dotRegex = /\./g;

const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(dotRegex);
  const versionsB = versionB.split(dotRegex);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());
    const b = Number(versionsB.shift());
    if (a !== b) { return a > b || Number.isNaN(b); }
  }
  return false;
};

const CacheBuster = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isLatestVersion, setIsLatestVersion] = useState(true);

  const refreshCacheAndReload = async () => {
    console.info('Clearing cache and hard reloading...'); // eslint-disable-line no-console
    if (caches) {
      const names = await caches.keys();
      names.forEach((name) => { caches.delete(name); });
    }
    window.location.reload(true);
  };

  const fetchMeta = async () => {
    try {
      const response = await fetch('/meta.json');
      const meta = await response.json();
      const latestVersion = meta.version;
      const currentVersion = global.appVersion;

      const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
      if (shouldForceRefresh) {
        console.info(`We have a new version - ${latestVersion}. Should force refresh`); // eslint-disable-line no-console
        setLoading(false);
        setIsLatestVersion(false);
        return;
      }
      console.info(`You already have the latest version - ${latestVersion}. No cache refresh needed.`); // eslint-disable-line no-console
      setLoading(false);
      setIsLatestVersion(true);
    } catch (error) {
      console.error('ERROR: CacheBuster: fetchMeta()', error); // eslint-disable-line no-console
    }
  };
  useEffect(() => {
    fetchMeta();
  }, []);

  return children({ loading, isLatestVersion, refreshCacheAndReload });
};

export default CacheBuster;
